export const environment = {
  production: false,
  apiUrl: 'https://test.back.graph.redcrossquest.com',
  supersetUrl: 'https://test.superset.graph.redcrossquest.com',
  rcqV1Url: 'https://test.redcrossquest.croix-rouge.fr',
  // Set to true to enable Superset embedded dashboards (requires Superset Cloud Run service)
  enableSuperset: false,
  environmentLabel: 'TEST',
};
